import { DirectiveOptions } from 'vue';

interface HTMLElementExtended extends HTMLElement {
    clickEsc(event: KeyboardEvent): void;
}

export default {
    bind(el, binding, vnode) {
        const exEl = el as HTMLElementExtended;
        exEl.clickEsc = (event) => {
            if (event.keyCode === 27 && vnode.context) {
                const expression = binding.expression as keyof typeof vnode.context;
                vnode.context[expression](event);
            }
        };
        document.body.addEventListener('keyup', exEl.clickEsc);
    },
    unbind(el) {
        const exEl = el as HTMLElementExtended;
        document.body.removeEventListener('keyup', exEl.clickEsc);
    },
} as DirectiveOptions;